import { STORY } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  stories: [],
  fetchSegmentsStatus: undefined,
  fetchStoriesStatus: undefined,
  segments: [],
  currentSlide: 0,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case STORY.FETCH_STORIES:
      return {
        ...state,
        fetchStoriesStatus: CONSTANTS.API.STARTED,
      };
    case STORY.FETCH_STORIES_SUCCEEDED:
      return {
        ...state,
        stories: action.payload,
        fetchStoriesStatus: CONSTANTS.API.SUCCEEDED,
        currentSlide: 0,
      };
    case STORY.FETCH_STORIES_FAILED:
      return {
        ...state,
        fetchStoriesStatus: CONSTANTS.API.FAILED,
      };
    case STORY.FETCH_SEGMENTS:
      return {
        ...state,
        fetchSegmentsStatus: CONSTANTS.API.STARTED,
      };
    case STORY.FETCH_SEGMENTS_SUCCEEDED:
      return {
        ...state,
        segments: action.payload,
        fetchSegmentsStatus: CONSTANTS.API.SUCCEEDED,
      };
    case STORY.FETCH_SEGMENTS_FAILED:
      return {
        ...state,
        fetchSegmentsStatus: CONSTANTS.API.FAILED,
      };
    case STORY.NEXT_SLIDE:
      return {
        ...state,
        currentSlide:
          state.currentSlide + 1 < state.stories[0].slides.length ? state.currentSlide + 1 : state.currentSlide,
      };
    case STORY.PREV_SLIDE:
      return {
        ...state,
        currentSlide: state.currentSlide - 1 > -1 ? state.currentSlide - 1 : state.currentSlide,
      };
    default:
      return state;
  }
};
